//@flow

//import type { APIresponse, rawObjectFromAPI } from "../flowTypes.js";

const ADD_ACTIVE_CONNECT = "ADD_ACTIVE_CONNECT";
const REMOVE_ACTIVE_CONNECT = "REMOVE_ACTIVE_CONNECT";
const DROP_ACTIVE_CONNECTS = "DROP_ACTIVE_CONNECTS";

export const addActiveConnect = name => {
  const action = {
    type: ADD_ACTIVE_CONNECT,
    name,
  };

  return action;
};

export const removeActiveConnect = name => {
  const action = {
    type: REMOVE_ACTIVE_CONNECT,
    name,
  };

  return action;
};

export const dropActiveConnects = () => {
  const action = {
    type: DROP_ACTIVE_CONNECTS,
  };

  return action;
};
